export default (state, { id }) => id
  && state.customers.data
  && state.customers.data[id]
  && state.customers.data[id].title
